export const SSL_ACTIVE_STEP_INDEXES = {
    STEP_1: {
        value: 0,
        componentName: 'SslActiveCsrStep',
        tabLabel: 'ssl.ssl_steps.csr_and_domain.label',
    },
    STEP_2: {
        value: 1,
        componentName: 'SslActiveDcvStep',
        tabLabel: 'ssl.ssl_steps.select_dcv_method.label',
    },
    STEP_3: {
        value: 2,
        componentName: 'SslActiveAdminEmailStep',
        tabLabel: 'ssl.ssl_steps.admin_email.label',
    },
    STEP_4: {
        value: 3,
        componentName: 'SslActiveReviewStep',
        tabLabel: 'ssl.ssl_steps.review_and_submit.label',
    },
};

export const SSL_DV_ACTIVE_STEP_INDEXES = {
    STEP_1: {
        value: 0,
        componentName: 'SslActiveCsrStep',
        tabLabel: 'ssl.ssl_steps.csr_and_domain.label',
    },
    STEP_2: {
        value: 1,
        componentName: 'SslActiveDcvStep',
        tabLabel: 'ssl.ssl_steps.select_dcv_method.label',
    },
    STEP_3: {
        value: 2,
        componentName: 'SslActiveReviewStep',
        tabLabel: 'ssl.ssl_steps.review_and_submit.label',
    },
};

export const SSL_DCV_METHODS = {
    DNS: {
        key: 'DNS',
        value: 'DNSDCValidation',
        label: 'DNS Validation',
        labelFullTranslateKey: 'ssl.active_step_review.domain_dcv_hints.dns',
        hintTranslateKey: 'ssl.active_step_dcv.hints.dns',
    },
    HTTP: {
        key: 'HTTP',
        value: 'HTTPDCValidation',
        label: 'HTTP Validation',
        labelFullTranslateKey: 'ssl.active_step_review.domain_dcv_hints.http',
        hintTranslateKey: 'ssl.active_step_dcv.hints.http',
    },
    EMAIL: {
        key: 'EMAIL',
        value: 'ApproverEmail',
        label: 'Email Validation',
        labelFullTranslateKey: 'ssl.active_step_review.domain_dcv_hints.email',
        hintTranslateKey: 'ssl.active_step_dcv.hints.email',
    },
};

export const CSR_PARSED_RAW_TYPES = {
    CN: 'DOMAIN',
    L: 'LOCALITY',
    ST: 'STATE',
    O: 'ORGANIZATION',
    OU: 'ORGANIZATION_UNIT',
    E: 'EMAIL',
    C: 'COUNTRY',
    basicConstraints: 'BASIC_CONSTRAINTS',
    keyUsage: 'KEY_USAGE',
    extKeyUsage: 'EXT_KEY_USAGE',
    subjectAltName: 'SUBJECT_ALT_NAME',
};

export const CSR_PARSED_TYPES = {
    DOMAIN: {
        key: 'DOMAIN',
        translateKey: 'ssl.csr_decode_type.domain',
        label: 'Domain',
    },
    LOCALITY: {
        key: 'LOCALITY',
        translateKey: 'ssl.csr_decode_type.locality',
        label: 'Locality',
    },
    STATE: {
        key: 'STATE',
        translateKey: 'ssl.csr_decode_type.state',
        label: 'State',
    },
    ORGANIZATION: {
        key: 'ORGANIZATION',
        translateKey: 'ssl.csr_decode_type.organization',
        label: 'Organization',
    },
    ORGANIZATION_UNIT: {
        key: 'ORGANIZATION_UNIT',
        translateKey: 'ssl.csr_decode_type.organization_unit',
        label: 'Organization Unit',
    },
    EMAIL: {
        key: 'EMAIL',
        value: 'EMAIL',
        translateKey: 'ssl.csr_decode_type.email',
        label: 'Email',
    },
    COUNTRY: {
        key: 'COUNTRY',
        translateKey: 'ssl.csr_decode_type.country',
        label: 'Country',
    },
    BASIC_CONSTRAINTS: {
        key: 'BASIC_CONSTRAINTS',
        translateKey: 'ssl.csr_decode_type.basic_constraints',
        label: 'Basic Constrains',
    },
    KEY_USAGE: {
        key: 'KEY_USAGE',
        translateKey: 'ssl.csr_decode_type.key_usage',
        label: 'Key Usage',
    },
    EXT_KEY_USAGE: {
        key: 'EXT_KEY_USAGE',
        translateKey: 'ssl.csr_decode_type.ext_key_usage',
        label: 'Extended Key Usage',
    },
    SUBJECT_ALT_NAME: {
        key: 'SUBJECT_ALT_NAME',
        translateKey: 'ssl.csr_decode_type.subject_alt_name',
        label: 'DNS Subject Alt Names',
    },
};

export const SSL_DOMAIN_TYPES = {
    SINGLE_DOMAIN: {
        key: 'SINGLE_DOMAIN',
        value: 'Single-Domain',
    },
    MULTI_DOMAIN: {
        key: 'MULTI_DOMAIN',
        value: 'Multi-Domain',
    },
    WILDCARD: {
        key: 'WILDCARD',
        value: 'Wildcard',
    },
    UC: {
        key: 'UC',
        value: 'Unified-Communications',
    },
};

export const SSL_VALIDATION_TYPES = {
    DV: {
        key: 'DV',
        translateKey: 'ssl.ssl_validation_types.dv',
        fullTranslateKey: 'ssl.ssl_validation_types.dv_full',
    },
    OV: {
        key: 'OV',
        translateKey: 'ssl.ssl_validation_types.ov',
        fullTranslateKey: 'ssl.ssl_validation_types.ov_full',
    },
    EV: {
        key: 'EV',
        translateKey: 'ssl.ssl_validation_types.ev',
        fullTranslateKey: 'ssl.ssl_validation_types.ev_full',
    },
};

export const MULTI_DOMAIN_CONFIGS = {
    DOMAINS_INCLUDED: 3,
    MAX_TOTAL_DOMAINS: 100,
    MAX_SANS_TO_ADD: 97,
};

export const SSL_DOMAIN_TYPES_HAS_ADD_DOMAINS = [
    SSL_DOMAIN_TYPES.MULTI_DOMAIN.value,
    SSL_DOMAIN_TYPES.UC.value,
];

export const SSL_HTTP_VALIDATION_FOLDER = '/.well-known/pki-validation/';
